export default __webpack_public_path__ + "static/media/facebook.1e4e4ffa.svg";